<template lang="html">
  <button @click="clickQrFileButton">
    <img :src="util.getImagePath('browse_img_white@2x.png')" :srcset="util.getImageSet('browse_img_white')">
    <input
      ref="qrFileInput"
      style="display: none;"
      @change="onChangeInput"
      type="file"
      name="image"
      accept="image/*">
  </button>
</template>

<script>
import { scan } from '../misc/scanner.js'
import { imageDataFromFile } from '../misc/image-data.js'
import CommonAPI from '../mixins/CommonAPI.vue'

export default {
  mixins: [ CommonAPI ],
  props: {
    manageSelectFileByMyself: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChangeInput (event) {
      const files = [...event.target.files]
      const resultPromises = files.map(this.processFile)
      resultPromises.forEach(this.onDetect)
      // console.log(Promise.all(resultPromises))
    },
    async processFile (file) {
      const imageData = await imageDataFromFile(file)
      const scanResult = await scan(imageData)
      return { source: 'file', ...scanResult }
    },
    clickQrFileButton () {
      var self = this
      if (self.manageSelectFileByMyself) {
        self.$emit('clickQrFileButton')
      } else {
        self.$refs['qrFileInput'].click()
      }
    }
  }
}
</script>

<style scoped>
  button {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    background-color: transparent;
    padding: 0px;
    cursor: pointer;
  }

  img {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/QrcodeCapture.vue